import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { BookingIssue } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import {
  capitalizeEachFirstLetter,
  CheckboxBasedFilter,
  FiltersSharedProps,
} from '@avantstay/backoffice-core'

import { storeHolder } from '../../stores/TapeChartStore'

interface BookingIssuesProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const _BookingIssuesFilter: FC<BookingIssuesProps> = props => {
  const rootStore = storeHolder.store
  const { bookingIssues } = rootStore.stateStore

  const issuesOptions = (Object.keys(BookingIssue) as Array<keyof typeof BookingIssue>).map(
    issueKey => ({
      value: BookingIssue[issueKey],
      hasFullWidth: true,
      label: (
        <>
          {capitalizeEachFirstLetter(BookingIssue[issueKey]).replace(/_/g, ' ')}
          <span style={{ marginLeft: 'auto' }}>{bookingIssues?.[BookingIssue[issueKey]] || 0}</span>
        </>
      ),
    }),
  )

  return <CheckboxBasedFilter title="Booking Issues" options={issuesOptions} {...props} />
}

export const BookingIssuesFilter = observer(_BookingIssuesFilter)
